import React from 'react'
import { Grid } from '@mui/material'
import { ArrayInputLogicSupplier } from 'src/components/pages/sales/business-rule/logic/settingRule/ArrayInputLogicSupplier'

export const SettingRuleComponent = ({}) => {
  return (
    <>
      <Grid container spacing={3}>
        <ArrayInputLogicSupplier />
      </Grid>
    </>
  )
}
